
import { Navigate } from 'react-router-dom';
import React from 'react';
import { useUserProfile } from '../contexts/user/UserContext';

interface PublicRouteProps {
  element: React.ReactNode;
}

const PublicRoute = ({ element }: PublicRouteProps) => {
  const { user } = useUserProfile();
  return (
    <React.Fragment>
      {user ? <Navigate to={'/'} replace={true} /> : element}
    </React.Fragment>
  );
};

export default PublicRoute;
